module.exports = [
  'popularity',
  'speed',
  'earnings'
]
